{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2021                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCWXOCR.Consts;

interface

const
  LB = #13;
  MESSAGEID = 'MessageID';
  OCRINITIALIZED = 'OCR_INIT';
  MESSAGEDATA = 'MessageData';
  CONTROL_ID = 'TTMSFNCWXOCRID#';
  FINISHEDOCR = 'OCRFINISHED';
  LOGOCR = 'OCRLOG';
  ERROR = 'TMSFNCWXOCRERROR';
  TERMINATEOCR = CONTROL_ID + 'Terminate()';
  TESSERACTWORK = CONTROL_ID+'work("%s","%s","%s")';
  INITWORKER = '' + CONTROL_ID + 'InitWorker(%s, "%s");';
  TESSERACTJS = 'https://unpkg.com/tesseract.js@5/dist/tesseract.min.js';


  function LoadWXOCRScripts(AControlID, ADataObject: String):string;

implementation

function LoadWXOCRScripts(AControlID, ADataObject: String):string;
begin
  Result := 'var ' + AControlID + 'scheduler; ' + LB + LB +
            'var ' + AControlID + 'initialized = false;' + LB + LB +
            'async function '+AControlID+'InitWorker(count, lang) {' + LB +
            '  if (' + AControlID + 'initialized) return;' + LB +
            '  ' + AControlID + 'scheduler = null;' + LB +
            '  ' + AControlID + 'scheduler = Tesseract.createScheduler();' + LB +
            '  Tesseract.setLogging(true);' + LB + LB +
            '  for (let i = 0; i < count; i++) {' + LB +
            '    var worker = await Tesseract.createWorker(lang, 1, {' + LB +
            '      logger: m => '+AControlID+'LogOCR(m),'+ LB +
            '      errorHandler: e => '+AControlID+'ErrorHandler(e)'+ LB +
            '    });' + LB + LB +
            '    ' + AControlID + 'scheduler.addWorker(worker);' + LB +
            '    ' + AControlID + 'initialized = true;' + LB +
            '  }' + LB +
            '  var o = ' + ADataObject + ';' + LB +
            '  o["EventName"] = "' + OCRINITIALIZED + '";' + LB +
            '  var customdata = true;' + LB +
            '  var cd = encodeURIComponent(JSON.stringify(customdata))' + LB +
            '  ' + AControlID + 'sendObjectMessage(JSON.stringify(o), cd);' + LB +
            '}'+LB+LB+
            'function '+AControlID+'LogOCR(m) {' + LB +
            '  var o = ' + ADataObject + ';' + LB +
            '  o["EventName"] = "' + LOGOCR + '";' + LB +
            '  var customdata = m;' + LB +
            '  var cd = encodeURIComponent(JSON.stringify(customdata))' + LB +
            ' ' + AControlID + 'sendObjectMessage(JSON.stringify(o), cd);' + LB +
            '}'+LB+LB+
            'function '+AControlID+'ErrorHandler(e) {' + LB +
            '  var o = ' + ADataObject + ';' + LB +
            '  o["EventName"] = "' + ERROR + '";' + LB +
            '  var customdata = e;' + LB +
            '  var cd = encodeURIComponent(JSON.stringify(customdata))' + LB +
            ' ' + AControlID + 'sendObjectMessage(JSON.stringify(o), cd);' + LB +
            '}' + LB + LB +
            'async function '+AControlID+'Terminate() {' + LB +
            '  ' + AControlID + 'initialized = false;' + LB +
            '  await ' + AControlID + 'scheduler.terminate();' + LB +
            '}' + LB + LB +
            'async function '+AControlID+'work(lang, imgUrl, id) {' + LB +
            '  if(' + AControlID + 'initialized) {' + LB +
            '    result = await '+AControlID+'scheduler.addJob("recognize", imgUrl, {},id);' + LB +
            '    var jsonResult = {}; ' + LB +
            '    jsonResult.id = id;' + LB +
            '    jsonResult.jobId = result.jobId;' + LB +
            '    jsonResult.text = result.data.text;' + LB +
            '    jsonResult.confidence = result.data.confidence; ' + LB +
            '    jsonResult.bbox = result.data.bbox;' + LB +
            '    jsonResult.hocr = result.data.hocr;' + LB +
            '    jsonResult.tsv = result.data.tsv;' + LB +
            '    jsonResult.paragraphs = [];' + LB +
            '    result.data.paragraphs.forEach(paragraph => {' + LB +
            '      var paragraphResult = {};' + LB +
            '      paragraphResult.text = paragraph.text;' + LB +
            '      paragraphResult.confidence = paragraph.confidence;' + LB +
            '      paragraphResult.bbox = paragraph.bbox;' + LB +
            '      paragraphResult.lines = [];' + LB +
            '      paragraph.lines.forEach(line => {' + LB +
            '        var lineResult = {};' + LB +
            '        lineResult.bbox = line.bbox;' + LB +
            '        lineResult.text = line.text;' + LB +
            '        lineResult.confidence = line.confidence;' + LB +
            '        lineResult.words = [];' + LB +
            '        line.words.forEach(word => {' + LB +
            '          var wordResult = {};' + LB +
            '          wordResult.bbox = word.bbox;' + LB +
            '          wordResult.text = word.text;' + LB +
            '          wordResult.confidence = word.confidence;' + LB +
            '          lineResult.words.push(wordResult);' + LB +
            '        });' + LB +
            '        paragraphResult.lines.push(lineResult);' + LB +
            '      });' + LB +
            '      jsonResult.paragraphs.push(paragraphResult);' + LB +
            '    });' + LB +
            '    jsonResult.lines = [];' + LB +
            '    result.data.lines.forEach(line => {' + LB +
            '      var lineResult = {};' + LB +
            '      lineResult.bbox = line.bbox;' + LB +
            '      lineResult.text = line.text;' + LB +
            '      lineResult.confidence = line.confidence;' + LB +
            '      lineResult.words = [];' + LB +
            '      line.words.forEach(word => {' + LB +
            '        var wordResult = {};' + LB +
            '        wordResult.bbox = word.bbox;' + LB +
            '        wordResult.text = word.text;' + LB +
            '        wordResult.confidence = word.confidence;' + LB +
            '        lineResult.words.push(wordResult);' + LB +
            '      });' + LB +
            '      jsonResult.lines.push(lineResult);' + LB +
            '    });' + LB +
            '    jsonResult.words = [];' + LB +
            '    result.data.words.forEach(word => {' + LB +
            '      var wordResult = {};' + LB +
            '      wordResult.bbox = word.bbox;' + LB +
            '      wordResult.text = word.text;' + LB +
            '      wordResult.confidence = word.confidence;' + LB +
            '      jsonResult.words.push(wordResult); ' + LB +
            '    });' + LB +
            '    var o = ' + ADataObject + ';' + LB +
            '    o["EventName"] = "' + FINISHEDOCR + '";' + LB +
            '    var customdata = jsonResult;' + LB +
            '    var cd = encodeURIComponent(JSON.stringify(customdata))' + LB +
            '    ' + AControlID + 'sendObjectMessage(JSON.stringify(o), cd);' + LB +
            '  }' + LB +
            '}' + LB + LB
            ;
  end;
end.
